// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const GridIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="GridIcon" ref={forwardedRef} {...props}>
      <path d="M14.132 14.133h2.75v2.75h-2.75z" />
      <path d="M8.631 14.133h2.75v2.75h-2.75z" />
      <path d="M3.13 14.133h2.75v2.75H3.13z" />
      <path d="M14.132 8.633h2.75v2.75h-2.75z" />
      <path d="M8.631 8.633h2.75v2.75h-2.75z" />
      <path d="M3.13 8.633h2.75v2.75H3.13z" />
      <path d="M14.132 3.13h2.75v2.75h-2.75z" />
      <path d="M8.631 3.13h2.75v2.75h-2.75z" />
      <path d="M3.13 3.13h2.75v2.75H3.13z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const GridIcon = /* @__PURE__ */ Object.assign(GridIconComponent, {
  displayName: 'GridIcon',
});
